<style scoped lang="scss">
    .upload-file-container {
        border: thin #888 dashed;
        padding: 30px;
        background-color: #efefef;
        font-size: 1.1em;
    }

    .custom-file-upload {
        width: 100%;
        padding: 20px;
        border: thin solid #888;
        border-radius: 4px;
    }
</style>

<template>
    <div class="uk-grid">
        <div class="uk-grid uk-width-1-1" v-for="upload in uploads">
            <div class="uk-width-1-1">
                <span class="uk-align-left">{{ upload.file.name }}</span>
                <span class="uk-align-right">
                    <button class="uk-button uk-button-secondary" @click="cancelUpload(upload)">Cancel</button>
                </span>
            </div>
            <div class="uk-width-1-1">
                <progress :value="upload.progress" class="uk-width-1-1" max="100"/>
            </div>
        </div>
        <div class="uk-width-1-1 uk-margin-remove">
            <input type="file" ref="file" @change="addPickedFile($event);" :accept="accepts" multiple style="display: none">
            <p style="font-size: 1.2em;">Please upload your document(s)</p>
            <label for="files-upload" class="custom-file-upload uk-button uk-width-1-2 uk-align-center" @click.prevent="$refs.file.click()">
                <span class="a-upload-2"></span> &nbsp;UPLOAD FILE
            </label>
        </div>
    </div>

</template>

<script>
    export default {
        name: "FileUploadRow",
        props: {
            uploadUrl: {
                type: String,
                required: true,
            },
            accepts: {
                type: String,
                default: null,
            },
            fileType: {
                type: String,
                default: '',
            },
            params: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {
                uploads: [],
            }
        },
        methods: {
            reset() {

            },
            addPickedFile($event) {
                _.each($event.target.files, file => {
                    file.status = 'uploading';
                    let upload = {
                        file,
                        progress: 0,
                        cancelToken: axios.CancelToken.source(),
                    };
                    this.uploads.push(upload)
                    this.uploadFile(upload);
                })
            },
            addFile($event) {
                _.each($event.dataTransfer.files, file => {
                    file.status = 'uploading';
                    let upload = {
                        file,
                        progress: 0,
                        cancelToken: axios.CancelToken.source(),
                    };
                    this.uploads.push(upload)
                    this.uploadFile(upload);
                })

            },
            removeFile(upload) {
                this.$refs.file.value = ''
                let uploads = [];
                _.each(this.uploads, existing => {
                    if(existing.file.name !== upload.file.name) {
                        uploads.push(existing);
                    }
                })
                this.uploads = uploads;
            },
            uploadFile(upload) {
                let data = new FormData();
                data.append('file', upload.file);
                data.append('file_type', this.fileType);
                for(var i in this.params) {
                    data.append(i, this.params[i]);
                }
                axios.post(this.uploadUrl, data, {
                    onUploadProgress: $event => this.onUploadProgress($event, upload),
                    cancelToken: upload.cancelToken.token,
                }).then(r => {
                    this.removeFile(upload);
                    this.$emit('uploaded', upload);
                }).catch(e => {

                })
            },
            cancelUpload(upload) {
                upload.cancelToken.cancel('');
                this.removeFile(upload);
            },
            onUploadProgress($event, upload) {

                let progress = 0;
                if($event.total > 0) {
                    progress = ($event.loaded / $event.total).toFixed(2) * 100;
                }
                upload.progress = progress;
                console.log($event, upload);
            },
        },
    }
</script>
